import { render } from "./PayFileCollectionShell.vue?vue&type=template&id=6fa44285&scoped=true"
import script from "./PayFileCollectionShell.vue?vue&type=script&lang=js"
export * from "./PayFileCollectionShell.vue?vue&type=script&lang=js"

import "./PayFileCollectionShell.vue?vue&type=style&index=0&id=6fa44285&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa44285"]])

export default __exports__